import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const SECRETARY_DELETE_REQUEST = 'DELETE_SECRETARY_REQUEST';
export const SECRETARY_DELETE_FAILURE = 'DELETE_SECRETARY_FAILURE';
export const SECRETARY_DELETE_SUCCESS = 'DELETE_SECRETARY_SUCCESS';

export const deleteSecretary = (id) => {
    const params = [];
    params['id'] = id;
    return function(dispatch) {
        dispatch(deleteRequest());
        return axios(apiRequestOptions(apiPath.SECRETARY.DELETE, null, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(deleteSuccess(id));
                dispatch(addSuccessMessage('Secretary successfully deleted'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const deleteRequest = () => {
    return { type: SECRETARY_DELETE_REQUEST }
};

const deleteFailure = error => {
    return { type: SECRETARY_DELETE_FAILURE, error }
};

const deleteSuccess = secretary => {
    return { type: SECRETARY_DELETE_SUCCESS, secretary }
};